import apiClient, { ApiResponse } from '../utils/api';

export interface AssistantHistoryItem {
  role: 'user' | 'assistant';
  content: string;
}

export interface AssistantChatResponse {
  answer: string;
  disclaimer?: string;
  citations?: string[];
  used_ai?: boolean;
  error?: string;
}

export async function askAssistant(message: string, history: AssistantHistoryItem[] = []): Promise<AssistantChatResponse> {
  const res: ApiResponse<AssistantChatResponse> = await apiClient.post('/api/assistant/chat', {
    message,
    history,
  });
  if (res.data) return res.data;
  throw new Error(res.error || 'Assistant unavailable');
}
